<template>
  <div v-if="isAuthenticated === true">
    <div class="whole q-pt-xl">
      <div class="main-parent ">
        <div class="left-parent" id="left-panel">
          <img src="../../assets/login_img2.webp" alt="Shopping Cart" />
          <div class="note" v-if="addProductTab">
            <div class="q-mb-lg">
              <input
                class="radio"
                type="radio"
                id="radio"
                value="1"
                v-model="tabClick"
                name="page"
              />
              <label class="add" for="radio">Add Product</label>
            </div>
            <div class="q-mb-lg">
              <input
                class="radio"
                type="radio"
                id="radio"
                value="2"
                v-model="tabClick"
                name="page"
              />
              <label for="radio">Smart Price Suggestion</label>
            </div>
            <div class="q-mb-sm">
              <input
                class="radio"
                type="radio"
                id="radio"
                value="3"
                v-model="tabClick"
                name="page"
              />
              <label for="radio">confirm</label>
            </div>
          </div>
        </div>
        <div class="right-parent " id="right-panel">
          <div class="wrapper">
            <div class="button row">
              <div>
                <button
                  v-bind:class="{ blue: addProductTab, white: !addProductTab }"
                  @click="addProductTab = true"
                  id="button1"
                >
                  Add Product
                </button>
              </div>
              <div>
                <button
                  v-bind:class="{ blue: !addProductTab, white: addProductTab }"
                  @click="addProductTab = false"
                  id="button1"
                >
                  Bulk Upload
                </button>
              </div>
            </div>
            <div v-if="addProductTab">
              <div v-if="tabClick === 1">
                <div>
                  <h3 class="text-4 q-ml-xl q-my-md q-pr-xl q-mr-xl">
                    Hello ! Please add your product details here.
                  </h3>

                  <form class="form-1">
                    <div class="my row ">
                      <div class="col-6 q-pl-xl q-pr-lg l">
                        <label><b>Product Name</b></label>
                        <input
                          type="text"
                          class="inputfield"
                          v-model="obj.product_name"
                          style="text-transform:uppercase"
                        />
                      </div>
                      <div class="col-6 q-pr-xl q-pl-lg">
                        <label><b>Product Tags</b></label>
                        <input
                          type="text"
                          class="inputfield"
                          v-model="obj.product_tags"
                        />
                      </div>
                    </div>
                    <div class="my row ">
                      <div class="col-6 q-pl-xl q-pr-lg l">
                        <label><b>Lower Boundary of Selling Price</b></label>
                        <input
                          type="number"
                          class="inputfield-number"
                          id="inputfield-number"
                          v-model="obj.product_lower_limit"
                        />
                        <p class="hint">
                          Selling price should not be less than this
                        </p>
                      </div>
                      <div class="col-6 q-pr-xl q-pl-lg">
                        <label><b>Upper Boundary of Selling Price</b></label>
                        <input
                          type="number"
                          class="inputfield-number"
                          v-model="obj.product_upper_limit"
                        />
                        <p class="hint">
                          Selling price should not be more than this
                        </p>
                      </div>
                    </div>
                    <div class="my row ">
                      <div class="col-6 q-pl-xl q-pr-lg l">
                        <label><b>ASIN(Amazon)</b></label>
                        <input
                          type="text"
                          class="inputfield"
                          v-model="obj.asin"
                        />
                      </div>
                      <div class="col-6 q-pr-xl q-pl-lg">
                        <label><b>Your URL*</b></label>
                        <input
                          type="url"
                          class="inputfield"
                          v-model="obj.client_url"
                        />
                      </div>
                    </div>
                    <div class="row q-px-xl">
                      <div class="">
                        <label><b>Competitor URLs*</b></label>
                        <div id="">
                          <div class="tags-input-container">
                            <div
                              class="tag"
                              v-for="(tag, index) in tags"
                              :key="'tag' + index"
                            >
                              <span
                                v-if="activeTag !== index"
                                @click="activeTag = index"
                                >{{ tag }}</span
                              >
                              <input
                                v-else
                                v-model="tags[index]"
                                v-focus
                                :style="{ width: tag.length + 'ch' }"
                                @keyup.enter="activeTag = null"
                                @blur="activeTag = null"
                              />
                              <span @click="removeTag(index)"
                                ><i class="fas fa-times-circle"></i
                              ></span>
                            </div>
                            <input v-model="tagValue" @keyup.enter="addTag" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>

                  <div
                    style="display:flex;justify-content:center;width:100%"
                    class="check_autogenerate"
                  >
                    <input
                      type="checkbox"
                      id="auto_suggest"
                      name="auto_suggest"
                      value="no"
                      v-model="auto_selected"
                    />
                    <label for="auto_suggest" class="q-ml-lg">
                      Autogenerate Competitor URLS?</label
                    ><br />
                  </div>

                  <div class="next">
                    <q-btn
                      size="md"
                      class="extension1 "
                      rounded
                      @click="tabClick = 2"
                      label="Next"
                    />
                  </div>
                </div>
              </div>
              <div>
                <div v-if="tabClick === 2">
                  <h3 class="text-1 q-mr-xl q-pr-xl">
                    Set rule for smart price suggestion
                  </h3>
                  <div class="tab">
                    <div class="subtab" id="panel-2">
                      <div class="text-6 q-mt-lg">
                        <label>My price should be </label
                        ><q-btn-dropdown
                          flat
                          style="color: black;font-weight:bold;font-size:13px;"
                          class="dropdown"
                          :label="obj.comparision"
                        >
                          <q-list>
                            <q-item
                              clickable
                              v-close-popup
                              @click="obj.comparision = ' LOWER THAN'"
                            >
                              <q-item-section>
                                <q-item-label>LOWER THAN</q-item-label>
                              </q-item-section>
                            </q-item>

                            <q-item
                              clickable
                              v-close-popup
                              @click="obj.comparision = ' HIGHER THAN'"
                            >
                              <q-item-section>
                                <q-item-label>HIGHER THAN</q-item-label>
                              </q-item-section>
                            </q-item>
                            <q-item
                              clickable
                              v-close-popup
                              @click="obj.comparision = 'EQUAL TO'"
                            >
                              <q-item-section>
                                <q-item-label>EQUAL TO</q-item-label>
                              </q-item-section>
                            </q-item>
                          </q-list>
                        </q-btn-dropdown>
                        <label>{{
                          obj.comparision == "EQUAL TO" ? "the" : "the"
                        }}</label
                        ><q-btn-dropdown
                          flat
                          style="color: black;font-weight:bold;font-size:13px;"
                          class="dropdown"
                          :label="obj.pricing"
                        >
                          <q-list>
                            <q-item
                              clickable
                              v-close-popup
                              @click="obj.pricing = 'PREMIUM'"
                            >
                              <q-item-section>
                                <q-item-label>PREMIUM</q-item-label>
                              </q-item-section>
                            </q-item>
                            <q-item
                              clickable
                              v-close-popup
                              @click="obj.pricing = 'CHEAPEST'"
                            >
                              <q-item-section>
                                <q-item-label>CHEAPEST</q-item-label>
                              </q-item-section>
                            </q-item>

                            <q-item
                              clickable
                              v-close-popup
                              @click="obj.pricing = 'AVERAGE'"
                            >
                              <q-item-section>
                                <q-item-label>AVERAGE</q-item-label>
                              </q-item-section>
                            </q-item>
                          </q-list> </q-btn-dropdown
                        ><label>Competitor.</label>
                      </div>
                      <div class="submit">
                        <div>
                          <q-btn
                            size="md"
                            value="click"
                            @click="addMore"
                            label="SUBMIT"
                          />
                        </div>
                      </div>
                    </div>

                    <div class="buttons">
                      <div>
                        <q-btn
                          size="md"
                          type="submit"
                          class="button3 "
                          @click="tabClick = 1"
                          label="Back"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <div v-if="tabClick === 3">
                    <h3 class="text-1">
                      Please confirm your product<br />details before submit
                    </h3>
                    <div class="tab">
                      <div class="subtab " id="panel-2">
                        <div class="text-10">
                          <div class="confirm-row row">
                            <div class="column3 col">
                              <label class="list-print">Product Name</label>
                            </div>
                            <div class="column4 col">
                              <label class="list-print">{{
                                obj.product_name
                              }}</label>
                            </div>
                          </div>
                          <div class="confirm-row row">
                            <div class="column3 col">
                              <label class="list-print">Product Tag</label>
                            </div>
                            <div class="column4 col">
                              <label class="list-print">{{
                                obj.product_tags
                              }}</label>
                            </div>
                          </div>

                          <div class="confirm-row row">
                            <div class="column3 col">
                              <label class="list-print"
                                >Lower Boundary of Selling Price</label
                              >
                            </div>
                            <div class="column4 col">
                              <label class="list-print">{{
                                obj.product_lower_limit
                              }}</label>
                            </div>
                          </div>

                          <div class="confirm-row row">
                            <div class="column3 col">
                              <label class="list-print"
                                >Upper Boundary of Selling Price</label
                              >
                            </div>
                            <div class="column4 col">
                              <label class="list-print">{{
                                obj.product_upper_limit
                              }}</label>
                            </div>
                          </div>

                          <div class="confirm-row row">
                            <div class="column3 col">
                              <label class="list-print">ASIN(Amazon)</label>
                            </div>
                            <div class="column4 col">
                              <label class="list-print">{{ obj.asin }}</label>
                            </div>
                          </div>
                        </div>

                        <div></div>
                      </div>

                      <div class="edit ">
                        <div>
                          <q-btn
                            size="md"
                            type="submit"
                            class="button7"
                            @click="tabClick = 1"
                            label="Edit"
                          />
                        </div>
                      </div>
                    </div>

                    <div class="buttons-tab2 row q-pt-lg">
                      <div class="col">
                        <q-btn
                          size="md"
                          class="button3"
                          @click="tabClick = 2"
                          label="Back"
                        />
                      </div>
                      <div class="submit-2 col">
                        <q-btn
                          size="md"
                          class="button3"
                          rounded
                          v-on:click="onsubmit"
                          label="Submit"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="!addProductTab">
              <h3 class="text-1">Upload your product details <br />in batch</h3>
              <br />
              <div id="panel">
                <div class="text-5 q-pt-md ">
                  <ol type="1">
                    <li>
                      To upload product details in batch,
                      <span>
                        <a
                          href="https://drive.google.com/uc?export=download&id=12o__YnibVk6XKtzQZdIHCqdgCYb2n2cn"
                          >download</a
                        >
                      </span>
                      the sample file
                    </li>
                    <li>
                      Add product details in required format as specified in the
                      sample file
                    </li>
                    <li>Upload your file</li>
                    <li>Analysis will be available within 24 hrs</li>
                  </ol>
                </div>

                <div class="upload">
                  <form class="fo">
                    <input
                      class="inp"
                      id="fileName"
                      type="text"
                      placeholder="Choose file"
                      v-model="fileName"
                    />
                    <input
                      type="file"
                      id="files"
                      accept=".xlsx"
                      class="hidden"
                      v-on:change="handleFileUpload1($event)"
                    />
                    <label class="uploadfile" for="files">Upload</label>

                    <q-btn class="button6" @click="checkfile()">SUBMIT </q-btn>
                  </form>
                  <div v-if="error1 == true" class="q-mt-sm">
                    <h6 class="text-negative">
                      * Selected file is not proper. Please resolve the below
                      errors and try reuploading the file
                    </h6>

                    <ol class="texterror">
                      <li v-for="item in error_msg" v-bind:key="item">
                        {{ item }}
                      </li>
                    </ol>
                  </div>

                  <div v-if="warning == true" class="q-mt-sm">
                    <h6 class="text-warning">
                      * Uploaded file has some warnings
                    </h6>

                    <ol>
                      <li
                        class="texterror"
                        v-for="item in warning_msg"
                        v-bind:key="item"
                      >
                        {{ item }}
                      </li>
                    </ol>
                  </div>
                </div>

                <p class="text-8 q-pt-xl q-mt-xl">
                  Note: To add multiple competitors' URL for a same product use
                  comma separated format
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TagsInput from "../../components/TagsInput.vue";
export default {
  name: "App",
  components: {
    TagsInput,
  },
  data() {
    return {
      isAuthenticated: false,
      preview: false,
      api_url: this.$store.state.API_URL[process.env.VUE_APP_ENV],
      addType: "ad",
      selected: "",
      model: null,
      fileName: "",
      data: [],
      backupList: [],
      result: [],
      right: true,
      basic: false,
      count: 0,
      fixed: false,
      urls: false,
      your_url: false,
      url: "",
      url1: "",
      url2: "",
      url3: "",
      url4: "",
      url5: "",
      urld1: false,
      urld2: false,
      urld3: false,
      urld4: false,
      urld5: false,
      url_count: 0,
      url_count1: 0,
      addProductTab: true,
      tabClick: 1,
      url: "",
      obj: {
        id: "",
        product_name: "",
        // brand:"",
        asin: "",
        product_tags: "",
        client_url: "",
        url_list: [],
        product_lower_limit: "",
        product_upper_limit: "",
        selling_price: "",
        selling_price_smart_price_perc: "25",
        my_price: "50",
        comparision: "LOWER THAN",
        pricing: "PREMIUM",
        price_comparision: "Can not be",
        type: "manual",
      },
      files: [],
      error: false,
      error1: false,
      warning: false,
      error_msg: "",
      warning_msg: "",
      competitor_url_list: [],
      checked_urls: [],
      previous_url: "",
      auto_selected: false,
      tagValue: "",
      tags: [],
      activeTag: null,
    };
  },
  mounted() {
    this.mounted1()
   
  },
  methods: {
    validate(url) {
      var pattern = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;
      if (pattern.test(url)) {
        //  alert("Url is valid");
        return true;
      }
      //  alert("Url is not valid!");
      return false;
    },
    mounted1(){
      this.$q.loading.show({
      message: "Authenticating please wait..",
    });
    console.log('3');
    if (this.$cookies.isKey("login_authentication")) {
      
      let encryptedText = this.$cookies.get("login_authentication");
      const decryptedText = this.$CryptoJS.AES.decrypt(
        encryptedText,
        process.env.VUE_APP_ENCRYPTION_SECRET_KEY
      ).toString(this.CryptoJS.enc.Utf8);
      console.log("decrypt: ", decryptedText);
      if (decryptedText == "authenticated") {
        this.$q.loading.hide();
        this.$store.dispatch("setPathName", "/pricewatch/addproduct");
        this.isAuthenticated = true;
      } else {
        this.$q.loading.hide();
        this.$router.push({
          name: "NotAuthenticated",
        });
        return;
      }
    }
    else if (this.$cookies.isKey("login_authentication1")) {
      let encryptedText = this.$cookies.get("login_authentication1");
      const decryptedText = this.$CryptoJS.AES.decrypt(
        encryptedText,
        process.env.VUE_APP_ENCRYPTION_SECRET_KEY
      ).toString(this.CryptoJS.enc.Utf8);
      console.log("decrypt: ", decryptedText);
      if (decryptedText == "authenticated") {
        this.$q.loading.hide();
      this.$router.push({
        name: "NotAuthenticated",
      });
      return;
      } else {
        this.$q.loading.hide();
        this.$router.push({
          name: "NotAuthenticated",
        });
        return;
      }
    }
    else if (this.$cookies.isKey("login_authentication2")) {
      let encryptedText = this.$cookies.get("login_authentication2");
      const decryptedText = this.$CryptoJS.AES.decrypt(
        encryptedText,
        process.env.VUE_APP_ENCRYPTION_SECRET_KEY
      ).toString(this.CryptoJS.enc.Utf8);
      console.log("decrypt: ", decryptedText);
      if (decryptedText == "authenticated") {
        this.$q.loading.hide();
        this.$store.dispatch("setPathName", "/pricewatch/addproduct/");
        this.isAuthenticated = true;
      }
      
      else {
        this.$q.loading.hide();
        this.$router.push({
          name: "NotAuthenticated",
        });
        return;
      }
    }
    else {
      this.$q.loading.hide();
      this.$router.push({
        name: "NotAuthenticated",
      });
      return;
    }
    },
    addTag() {
      console.log("this.tags", this.tags.length);
      if (this.tags.length == 5) {
        this.$alert(
          "Maximum URLs reached, only 5 competitors can be added ",
          "Sorry!",
          "error"
        );
        this.tagValue = "";
        return;
      }
      if (!this.tagValue == "" && this.validate(this.tagValue)) {
        this.tags.push(this.tagValue);
        this.tagValue = "";
      } else {
        this.$alert("Please enter proper url and try again", "Error", "error");
      }
    },
    removeTag(index) {
      this.tags.splice(index, 1);
    },
    checkError() {
      if (this.obj.product_name.trim() == "") {
        this.error = false;
        this.$q.notify({
          message: "Product Name is Required",
          color: "grey-3",
          textColor: "red",
        });
        return;
      }
      console.log(parseFloat(this.obj.product_upper_limit));
      console.log(parseFloat(this.obj.product_lower_limit));
      if (
        isNaN(parseFloat(this.obj.product_upper_limit)) ||
        isNaN(parseFloat(this.obj.product_lower_limit))
      ) {
        this.error = false;
        this.$q.notify({
          message: "please enter valid numbers in upper and lower boundary",
          color: "grey-3",
          textColor: "red",
        });
        return;
      }
      if (
        parseFloat(this.obj.product_upper_limit) <
        parseFloat(this.obj.product_lower_limit)
      ) {
        this.error = false;
        this.$q.notify({
          message: "upper boundary should not be less than lower limit",
          color: "grey-3",
          textColor: "red",
        });
        return;
      }
      if (
        parseFloat(this.obj.product_upper_limit) < 1 ||
        parseFloat(this.obj.product_lower_limit) < 1
      ) {
        this.error = false;
        this.$q.notify({
          message: "upper and lower boundaries should be greater than 0",
          color: "grey-3",
          textColor: "red",
        });
        return;
      }
      // else if(this.obj.type=="")
      // {
      //   this.error=false;
      //   this.$q.notify({
      //     message: "Select the Request Type",
      //         color: "grey-3",
      //         textColor: "red",
      //   });
      //   return;
      // }
      // else if(this.obj.brand.trim()=="")
      // {
      //   this.error=false;
      //   this.$q.notify({
      //     message: "Brand is Required",
      //         color: "grey-3",
      //         textColor: "red",
      //   });
      //   return;
      // }
      // else if(this.obj.selling_price.trim()=="")
      // {
      //   this.error=false;
      //   this.$q.notify({
      //     message: "Selling Price is Required",
      //         color: "grey-3",
      //         textColor: "red",
      //   });
      //   return ;
      // }
      this.error = true;
      return;
    },
    clear_all() {
      this.obj.id = "";
      this.obj.product_name = "";
      this.obj.asin = "";
      this.obj.product_tags = "";
      this.obj.client_url = "";
      this.obj.url_list = [];
      this.obj.product_lower_limit = "";
      this.obj.product_upper_limit = "";
      this.obj.selling_price = "";
      this.obj.selling_price_smart_price_perc = "25";
      this.obj.my_price = "50";
      this.obj.comparision = "Lower than";
      this.obj.pricing = "Premium";
      this.obj.price_comparision = "Can not be";
      this.obj.type = "manual";
      this.urld1 = false;
      this.urld2 = false;
      this.urld3 = false;
      this.urld4 = false;
      this.urld5 = false;
      this.url_count = 0;
      this.selected = "";
      this.data = [];
      this.backupList = [];
      this.result = [];
      this.right = true;
      this.basic = false;
      this.count = 0;
      this.fixed = false;
      this.urls = false;
      this.your_url = false;
      this.url = "";
      this.url1 = "";
      this.url2 = "";
      this.url3 = "";
      this.url4 = "";
      this.url5 = "";
      this.competitor_url_list = [];
      this.checked_urls = [];
      this.previous_url = "";
    },
    addMore() {
      this.$mixpanel.track('pricetracker/addproducts->addproduct/submit',{
        info : 'user submitted on add product'
      })
      this.checkError();
      if (this.validate(this.obj.client_url)) {
        this.tabClick = 3;
      } else {
        this.$q.notify({
          message: "Your URL is Invalid",
          color: "grey-3",
          textColor: "red",
        });
        return;
      }
      if (this.error) {
        //   alert("Hello");
        this.result.length = 0;
        //  this.result.status = "SUBMITTED";
        if (this.auto_selected) {
          this.obj["type"] = "auto_suggest";
        }
        this.obj["product_name"] = this.obj["product_name"].toUpperCase();
        this.result.push(this.obj);
        this.preview = true;
        console.log("RESULT :", this.result);
        console.log("productadded");
        // this.$q.notify({
        //           // message: "Product Added Successfully",
        //           // color: "grey-3",
        //           // textColor: "blue",
        //           c
        //         });
        // this.obj={
        //   id:"",
        //   type:"",
        //   product_name:"",
        //   url:"",
        //   brand:"",
        //   product_tags:"",
        //   asin:"",
        //   url_list:[],
        //   product_cost:"",
        //   selling_price:"",
        // };
        console.log("Done");
      }
    },
    submitUtil(selectedProductList) {
      return selectedProductList;
    },
    autogenerate() {
      if (this.previous_url == this.obj.client_url) {
        this.fixed = true;
        return;
      }
      this.previous_url = this.obj.client_url;
      this.checkError();
      if (!this.validate(this.obj.client_url)) {
        this.$q.notify({
          message: "Your URL is Invalid",
          color: "grey-3",
          textColor: "red",
        });
        return;
      }
      this.$q.loading.show({
        message: "Loading your competitor URLs, please wait..",
      });
      let details = [
        {
          url: this.obj.client_url,
        },
      ];
      let postURL = this.api_url + "/products/return_matching_url";
      this.$http.post(postURL, details).then((response) => {
        if (response.data) {
          console.log(response.data);
          this.competitor_url_list = response.data;
          this.$q.loading.hide();
          this.fixed = true;
        } else {
          this.$q.loading.hide();
          this.fixed = false;
          this.$alert(
            "Please enter competitor URLs manually",
            "Could not load competitor url!"
          );
        }
      });
    },
    async add_autogenerated() {
      console.log("this.checked_urls");
      console.log(this.checked_urls);
      if (this.url_count + this.checked_urls.length > 5) {
        this.$q.notify({
          message: "Only 5 URLs allowed",
          color: "grey-3",
          textColor: "red",
        });
        return;
      }
      for (let i = 0; i < this.checked_urls.length; i++) {
        this.obj.url_list.push(this.checked_urls[i][2]);
        console.log("URL list");
        console.log(this.obj.url_list);
        if (i + this.url_count == 0) {
          this.url1 = this.checked_urls[i][2];
          this.urld1 = true;
          if (i == this.checked_urls.length - 1) {
            this.url2 = "";
            this.urld2 = false;
            this.url3 = "";
            this.urld3 = false;
            this.url4 = "";
            this.urld4 = false;
            this.url5 = "";
            this.urld5 = false;
          }
        }
        if (i + this.url_count == 1) {
          this.url2 = this.checked_urls[i][2];
          this.urld2 = true;
          if (i == this.checked_urls.length - 1) {
            this.url3 = "";
            this.urld3 = false;
            this.url4 = "";
            this.urld4 = false;
            this.url5 = "";
            this.urld5 = false;
          }
        }
        if (i + this.url_count == 2) {
          this.url3 = this.checked_urls[i][2];
          this.urld3 = true;
          if (i == this.checked_urls.length - 1) {
            this.url4 = "";
            this.urld4 = false;
            this.url5 = "";
            this.urld5 = false;
          }
        }
        if (i + this.url_count == 3) {
          this.url4 = this.checked_urls[i][2];
          this.urld4 = true;
          if (i == this.checked_urls.length - 1) {
            this.url5 = "";
            this.urld5 = false;
          }
        }
        if (i + this.url_count == 4) {
          this.url5 = this.checked_urls[i][2];
          this.urld5 = true;
        }
      }
      this.url_count1 = this.checked_urls.length;
      this.checked_urls = [];
    },
    prev() {
      this.preview = true;
    },
    deleteFun(item) {
      let ind = this.result.indexOf(item);
      if (ind > -1) {
        this.result.splice(ind, 1);
      }
      //alert(ind.product_name);
    },
    editFun(item) {
      this.obj = item;
      this.preview = false;
      this.deleteFun(item);
    },
    autofill() {
      for (let i = 0; i < this.data.length; i++) {
        if (this.data[i].product_name.substring(0, 45) === this.selected) {
          this.obj.product_name = this.data[i].product_name;
          this.obj.product_cost = this.data[i].product_cost;
          this.obj.selling_price = this.data[i].selling_price;
        }
      }
    },
    checkErrorSubmit() {
      if (this.result.length == 0) {
        this.error = false;
        this.$q.notify({
          message: "Atleast One Product Required",
          color: "grey-3",
          textColor: "red",
        });
        return;
      }
      if (this.obj["type"] == "manual") {
        for (let i = 0; i < this.result.length; i++) {
          if (this.result[i].url_list.length == 0) {
            this.error = false;
            this.$q.notify({
              message: "Competitor Required ",
              color: "grey-3",
              textColor: "red",
            });
            return;
          }
        }
      }
      this.error = true;
      return;
    },
    onsubmit() {
      this.obj.url_list = this.tags;
      this.checkErrorSubmit();
      this.preview = false;
      console.log(this.obj.url_list);
      if (this.error) {
        //   this.data.push(this.obj);
        console.log(this.result);
        let postURL = this.api_url + `/products/trigger_price_watch/`+ this.$org_id.label;
        this.$http
          .post(postURL, this.submitUtil(this.result))
          .then((response) => {
            if (response.data) {
              this.$q.notify({
                message: "Added to Price Tracker",
                color: "grey-3",
                textColor: "blue",
              });
              this.$router.push({
                name: "PriceWatchResultHistory",
              });
              /*    this.$router.push({
                  name: "PriceWatchResultHistory",
                }); */
            } else {
              this.$q.notify({
                message: "Error Occured!",
                color: "grey-5",
                textColor: "negative",
              });
            }
          });
      }
     
    },
    handleFileUpload1(event) {
      this.files[0] = event.target.files[0];
      console.log(this.files[0]);
      this.fileName = event.target.files[0].name;
      //this.checkFile(this.files[0],category);
    },
    checkfile() {
      this.$mixpanel.track('pricetracker/addproduct/bulk upload/submit',{
        info:'User Submitted on bulk upload '
      })
      if (this.files[0] == undefined) {
        this.$q.loading.hide();
        this.$alert("Please select a file");
      } else {
        this.upload_to_s3();
      }
    },
    upload_to_s3() {
      this.$q.loading.show({
        message: "Uploading your file, please wait..",
      });
      this.error_msg = "";
      this.error1 = false;
      this.warning_msg = "";
      this.warning = false;
      var formData1 = new FormData();
      
      formData1.append("file1", this.files[0]);
      console.log("this.files[0]");
      console.log(this.files[0]);
      console.log("url started");
      let postURL = this.api_url + `/products/pricewatch_uploadfile/` + this.$org_id.label;
      console.log(postURL);
      this.$http.post(postURL, formData1).then((response) => {

        if (response.data[0] == true) {
          this.$q.loading.hide();
          this.warning_msg = response.data[1];
          if (this.warning_msg.length != 0) {
            this.warning = true;
          }
          this.$alert(
            "selected file has been uploaded.",
            "Uploaded Successfully!"
          );
        } else {
          this.$q.loading.hide();
          this.$alert(
            "selected file or data is not proper, please check it and re-upload again.",
            "Invalid data or file type!"
          );
          this.error_msg = response.data[0];
          this.error1 = true;
          this.warning_msg = response.data[1];
          if (this.warning_msg.length != 0) {
            this.warning = true;
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@400;700&display=swap");
.whole {
  font-family: "Poppins", sans-serif;
  font-size: 16px;
}
.main-parent {
  width: 100%;
  height: 100%;
  flex-direction: row;
  border-color: #00000029;
  border-width: 1px;
  align-items: center;
  justify-content: center;
  display: flex;
}
.left-parent {
  display: flex;
  background-color: transparent;
  height: 100%;
}
.right-parent {
  display: flex;
  width: 90%;
  background-color: white;
  height: 100%;
}
.text-1 {
  color: #545871;
  font-weight: bold;
  font-size: 35px;
  padding-top: 1.75%;
  text-align: left;
  width: 20em;
  padding-bottom: 1.75%;
  padding-left: 6%;
  opacity: 100%;
}
.tab {
  padding-left: 4%;
}
.text-4 {
  color: #545871;
  text-align: left;
  font-size: 38px;
  font-weight: bolder;
  padding-right: 20%;
}
.text-2 {
  position: absolute;
  display: flex;
  height: 50;
  width: 50;
}
#left-panel {
  width: 400px;
  height: 615px;
  box-shadow: inset 0px 3px 6px #00000029;
  position: relative;
  border-radius: 20px 0px 0px 20px;
  display: flex;
}
#left-panel .note {
  position: absolute;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  top: 30%;
  width: 75%;
  padding: 30px 15px;
  font-size: 17px;
  background: rgba(0, 0, 0, 0.3);
  mix-blend-mode: hard-light;
  border-radius: 20px 20px 20px 20px;
  color: white;
}
#left-panel .note ol {
  margin-left: 13px;
  opacity: 1 !important;
  font-weight: 600 !important;
}
#left-panel .note p {
  opacity: 1;
  font-weight: 600 !important;
}
#left-panel img {
  width: 100%;
  height: 100%;
  border-radius: 20px 0px 0px 20px;
}
#left-panel input,
label {
  display: inline;
}
#right-panel {
  width: 760px;
  height: 615px;
  position: relative;
  box-shadow: 0px 3px 10px #00000070;
}
.text-3 {
  padding-left: 10%;
}
.front {
  padding-top: 8%;
}
.column1 {
  padding-left: 6%;
  padding-bottom: 2%;
}
.confirm-row {
  width: 700px;
  height: 210px;
  width: 100%;
  height: 50%;
}
.column3 {
  padding-left: 6%;
  width: 50%;
  height: 50%;
  flex-direction: column;
  display: flex;
}
.column4 {
  height: 50%;
  width: 50%;
  flex-direction: column;
  display: flex;
}
label,
input {
  display: block;
}
.next {
  width: 140px;
  height: 30px;
  background-color: #ffffff;
  color: #545871;
  margin-left: 620px;
  margin-top: 3px;
}
.next button {
  width: 90px;
  height: 31px;
  font-weight: bold;
  color: #545871;
  background-color: white;
  border-radius: 100px 100px 100px 100px;
  border: 1px solid #545871;
  justify-content: center;
  border-width: 1px;
  cursor: pointer;
}
.submit-2 {
  margin-left: 305px;
}
#panel {
  padding-top: 4%;
  position: relative;
  background-color: #e0e0e0;
  margin-left: 6%;
  height: 395px;
  margin-right: 50px;
  box-shadow: 0px 3px 6px #00000029;
  opacity: 1;
  width: 670px;
}
#panel .text-5 {
  padding-left: 8%;
  position: absolute;
  width: 90%;
  font-size: 15px;
  color: black;
  font-weight: bold;
}
#panel-2 label,
drop-down {
  display: inline;
}
.subtab {
  width: 700px;
  height: 300px;
  position: relative;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 0px 0px 20px 0px;
  background-color: #e0e0e0;
  justify-content: center;
  align-content: center;
  padding-top: 5%;
  display: flex;
}
#panel-2 .text-6 {
  display: inline;
  position: absolute;
}
.text-6 {
  font-weight: bold;
}
#panel-2 .text-10 {
  display: inline;
  position: absolute;
  width: 100%;
}
.text-10 {
  font-weight: bold;
  width: 100%;
}
.submit {
  margin-top: 15%;
  align-items: center;
  display: flex;
}
.submit button {
  color: white;
  background-color: #102689;
  border-color: #707070;
  border-radius: 10px 10px 10px 10px;
  width: 130px;
  height: 45px;
  border-width: 1px;
  align-content: center;
  display: flex;
  font-weight: bold;
  border: 1px solid #707070;
  cursor: pointer;
}
.button3 {
  background-color: white;
  color: #545871;
  width: 90px;
  height: 40px;
  align-content: center;
  border-radius: 100px 100px 100px 100px;
  margin-left: 35px;
  font-weight: 550;
  border-width: 1px;
  border: 1px solid #545871;
  cursor: pointer;
}
.button4 {
  color: white;
  background-color: #102689;
  border-color: #707070;
  border-radius: 10px 10px 10px 10px;
  width: 150px;
  height: 55px;
  border-width: 1px;
  align-content: center;
  display: flex;
  font-weight: bold;
  position: relative;
  cursor: pointer;
}
.buttons {
  margin-top: 70px;
}
.buttons-tab2 {
  margin-top: 17px;
  margin-left: 22px;
}
.upload {
  margin-left: 80px;
  position: absolute;
  margin-top: 120px;
  padding: 4px 0px 0px 4px;
}
.upload input,
label {
  display: inline;
}
.fo {
  border: 1px solid #ced4da;
  border-radius: 4px 0px 0px 4px;
  align-items: center;
  display: flex;
}
.inp {
  padding: 4px 4px 4px 4px;
  border: 1px;
  color: black;
  width: 250px;
  height: 29px;
  pointer-events: none;
  background-color: #ffffff;
}
.text-8 {
  margin-top: 280px;
  margin-left: 15px;
  font-style: italic;
  color: #000000;
  font-size: 14px;
  font-weight: bold;
  opacity: 1;
}
.button5 {
  padding: 4px 4px 4px 4px;
  border: 1px;
  border-color: #ced4da;
  font-size: 15px;
  font-weight: 300;
  cursor: pointer;
}
.button7 {
  color: white;
  background-color: #102689;
  border-color: #707070;
  border-radius: 10px 10px 10px 10px;
  width: 95px;
  height: 40px;
  border-width: 1px;
  display: flex;
  font-weight: bold;
  cursor: pointer;
}
.button6 {
  background-color: #102689;
  color: white;
  font-weight: bold;
  padding: 4px 4px 4px 4px;
  border: 1px;
  font-size: 14px;
  border: none;
  height: 29px;
  width: 70px;
  align-items: center;
  justify-content: center;
  display: flex;
  cursor: pointer;
}
.white {
  background-color: #e2e2e2;
  color: black;
  font-weight: bold;
}
.blue {
  background-color: #102689;
  color: white;
  font-weight: bold;
}
#button1 {
  padding: 10px 14px 10px 10px;
  border: none;
  height: 45px;
  font-size: 14px;
  cursor: pointer;
}
.edit {
  font-size: 11px;
  margin-top: 13px;
  width: 100%;
  align-items: center;
  justify-content: center;
  display: flex;
}
.button8 {
  background-color: white;
  color: #545871;
  width: 110px;
  height: 40px;
  align-content: center;
  border-radius: 100px 100px 100px 100px;
  margin-left: 40%;
  font-weight: 550;
  border-width: 1px;
  cursor: pointer;
}
.note label {
  margin-left: 20px;
}
.inputfield-number {
  height: 28px;
  width: 100%;
  border-radius: 5px 5px 5px 5px;
  border: 1px solid #9597a6;
}
.inputfield {
  margin-bottom: 10px;
  width: 100%;
  height: 28px;
  border-radius: 5px 5px 5px 5px;
  border: 1px solid #9597a6;
}
.inputfield-competitor {
  width: 540px;
  height: 32px;
  border: 1px solid #9597a6;
  border-radius: 5px 5px 5px 5px;
}
.column2 {
  padding-left: 36px;
}
.list-print {
  margin-bottom: 5px;
}
.whole {
  height: 100%;
  width: 100%;
}
input {
  padding-left: 10px;
}
.radio {
  pointer-events: none;
}
.fileupload {
  flex-direction: row;
  display: flex;
}
.dropdown {
  background: #f1f2f6 0% 0% no-repeat padding-box;
  border: 1px solid #eeeeee;
  border-radius: 2px;
  margin: 7px;
  color: #0c1125;
  opacity: 0.65;
  font-size: 12px;
}
.add {
  cursor: pointer;
}
input[name="page"] {
  accent-color: #545871;
}
input[name="page"] {
  height: 12px;
  width: 12px;
  border-width: 12px;
}
input[name="page"]:checked {
  height: 18px;
  width: 18px;
  border-width: 36px;
}
.hint {
  font-size: 11px;
  color: grey;
}
.uploadfile {
  background-color: #e9ecef;
  width: 70px;
  height: 29px;
  align-items: center;
  justify-content: center;
  display: flex;
}
.form-1 {
  width: 100%;
}
.wrapper {
  width: 100%;
}
input:focus {
  outline: none;
}
.items {
  display: flex;
  justify-content: center;
  align-items: center;
}
.text-negative {
  font-size: 11px;
}
.text-warning {
  font-size: 11px;
}
.texterror {
  font-size: 10px;
}
.labl {
  display: block;
}
.labl > input {
  /* HIDE RADIO */
  visibility: hidden; /* Makes input not-clickable */
  position: absolute; /* Remove input from document flow */
}
.labl > input + div {
  /* DIV STYLES */
  cursor: pointer;
  border: 2px solid transparent;
  pointer-events: none;
}
.labl > input:checked + div {
  /* (RADIO CHECKED) DIV STYLES */
  background-color: rgb(209, 234, 248);
  border: 1px solid #cfce74;
  pointer-events: all;
}
.check_autogenerate {
  margin-top: 9px;
  font-size: 15px;
}
.check_autogenerate input {
  margin-top: 2px;
  width: 15x;
  height: 15px;
  cursor: pointer;
}
.tags-input-container {
  width: 666px;
  max-width: 666px;
  height: 120px;
  border: 1px solid #9597a6;
  border-radius: 5px 5px 5px 5px;
  overflow: scroll;
  overflow-y: scroll;
  overflow-x: scroll;
  padding: 8px;
  font-size: 12px;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE 10+ */
  &::-webkit-scrollbar {
    background: transparent; /* Chrome/Safari/Webkit */
    width: 0px;
  }
  input {
    float: left;
    width: 640px;
    height: 24px;
    border: 1px solid #9597a6;
    border-radius: 5px 5px 5px 5px;
    font-size: 12px;
    padding: 0 5px;
  }
  input:focus {
    outline: none;
  }
  .tag {
    float: left;
    padding: 2px 10px;
    margin-bottom: 8px;
    background-color: rgb(201, 223, 252);
    border-radius: 8px;
    cursor: pointer;
    &:hover {
      background-color: grey;
      border-radius: 8px;
    }
    span:first-child {
      margin-right: 2px;
    }
    svg {
      color: #666;
      &:hover {
        color: #333;
      }
    }
  }
}
</style>